import { useEffect } from 'react';
import { getAgencias } from '../lib/guiasAgenciasStorage';

export const AGENCIAS_EXPORT_MESSAGE_TYPE = 'naviex-agencias-export';

/**
 * Iframe para o app guia obter agências aprovadas (associação), quando admin está em outra origem.
 */
export default function AgenciasExportPage() {
  useEffect(() => {
    try {
      const agencias = getAgencias()
        .filter((a) => a.status === 'aprovado')
        .map((a) => ({
          id: a.id,
          razaoSocial: a.razaoSocial,
          cnpj: a.cnpj,
        }));
      if (window.parent !== window) {
        window.parent.postMessage({ type: AGENCIAS_EXPORT_MESSAGE_TYPE, agencias }, '*');
      }
    } catch (err) {
      if (window.parent !== window) {
        window.parent.postMessage({ type: AGENCIAS_EXPORT_MESSAGE_TYPE, agencias: [], error: String(err) }, '*');
      }
    }
  }, []);

  return <div className="p-4 text-sm text-gray-500">Agências enviadas.</div>;
}
